import type { InfoGridField, InfoGridFieldMap } from "./infoGrid.types"

type CreateInfoGridFieldsInput<TData> = {
  fields: InfoGridFieldMap<TData>
}

export function createInfoGridFields<TData extends Record<string, unknown>>(
  input: CreateInfoGridFieldsInput<TData>,
): InfoGridField<TData>[] {
  const { fields: fieldMap } = input

  return Object.entries(fieldMap).map(([key, field]) =>
    Object.assign({ id: key }, field),
  )
}
